import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=7a80d4f3&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=7a80d4f3&prod&scoped=true&lang=css"
import style1 from "./Auth.vue?vue&type=style&index=1&id=7a80d4f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a80d4f3",
  null
  
)

export default component.exports